module.exports = __webpack_public_path__ + "static/media/coffee.750cb0a0.jpg";